export default "__VITE_ASSET__e540e766__"